<template>
    <v-text-field
        v-bind="{
            value,
            type: 'url',
            dense: true,
            outlined: true,
            'hide-details': 'auto',
            placeholder: 'https://...',
            clearable: true,
            ...$attrs,
        }"
        @blur="blur"
        v-on="$listeners"
    />
</template>

<script>
import getRulesMixin from '@/mixins/get-form-rules';

export default {
    mixins: [getRulesMixin],
    props: {
        value: {
            type: String,
            default: '',
        },
    },
    methods: {
        blur() {
            this.$emit('input', this.formatUrl(this.value));
            this.$emit('change', this.formatUrl(this.value));
        },
        formatUrl(url) {
            url = url?.trim();
            // only add https:// if it does not start with it yet and does user is not in the process of typing it
            const pattern = /^(|https?:\/\/.*)$/;
            if (!url || pattern.test(url)) {
                return url || '';
            } else {
                return 'https://' + url;
            }
        },
    },
};
</script>

<style lang="scss" scoped></style>
